import * as React from 'react';
import {WithStyles, withStyles, Dialog} from '@material-ui/core';
import {EcoTransferMethod, IEcoSplitSetting, IEcoSetting} from "@app-types/websocket/economy.types";
import {IFamilyMember} from "@app-types/websocket/family.types";
import TranslateNew from "@translate/TranslateNew";

import { IEcoMonthlyPurchases } from '@containers/economy/economy.internal.types';
import { getPurchaseBalance, getTransferBalance } from '@helpers/EconomyHelper';
import { ecoContainerStyle } from './Container.style';
import { connect } from 'react-redux';
import { FamilyMemberType } from '@services/family/family.constants';
import Button from '@components/common/button/Button';

const tn = TranslateNew.getInstance();

interface IBalanceProps extends WithStyles<typeof ecoContainerStyle>
{
    purchases: IEcoMonthlyPurchases[];
    family: IFamilyMember[];
    userId:number;
    split:IEcoSplitSetting[];
    currency:string;
    swishF1:string,
    swishF2:string,
    venmoF1:string,
    venmoF2:string,
    cashappF1:string,
    cashappF2:string,
    paypalF1: string;
    paypalF2: string;
    iAmF1:boolean,
    paymentMethod:"SWISH"|"VENMO"|"CASHAPP" | "PAYPAL",
    onNewTransfer:(sum:number, method: EcoTransferMethod) => void,
    showSettings:() => void,
}

interface IState {

    showRegisterInApp:boolean;

    currency:string;
    myPercentage:number;
    swishF1:string,
    swishF2:string,
    venmoF1:string,
    venmoF2:string,
    cashappF1:string,
    cashappF2:string,
    paypalF1: string;
    paypalF2: string;

    paymentMethod:"SWISH"|"VENMO"|"CASHAPP" | "PAYPAL",
}

class Balance extends React.Component<IBalanceProps, IState> {
    constructor(props: IBalanceProps) {
        super(props);
    
        this.state = {
          ...this.buildNewState(props),
        };
        
      }


    public componentDidUpdate(oldProps:IBalanceProps) {
        if (this.props.split !== oldProps.split) {
            this.setState(this.buildNewState(this.props));
        }
    }

    public buildNewState(props:IBalanceProps):IState  {

        let myPercentage = 50;

        if (props.split.length>0) {
            const lastSetting = props.split[props.split.length-1];
            const lastSplit = (lastSetting && Array.isArray(lastSetting.split)) ? lastSetting.split : [];
            const mySplitIndex = lastSplit.findIndex((mem) => mem && mem.accountId === this.props.userId);
            if (mySplitIndex > -1) {
                const mySplit = lastSplit[mySplitIndex];
                myPercentage = mySplit.percentage;
            }
        }
        
    
        return ({
          showRegisterInApp:false,
          swishF1:props.swishF1 || "",
          swishF2: props.swishF2 || "",
          venmoF1: props.venmoF1 || "",
          venmoF2: props.venmoF2 || "",
          cashappF1:props.cashappF1 || "",
          cashappF2:props.cashappF2 || "",
          paypalF1: props.paypalF1 || "",
          paypalF2: props.paypalF2 || "",

          paymentMethod:props.paymentMethod,
          currency:props.currency,
          myPercentage,
        });
        
    }

    public render() {
        const { classes, userId, purchases, paymentMethod} = this.props;
    
        let totalBalance = 0;
        let thisMonthBalance = 0;
        let hasSharedAccountActivity = false;
    
        const today: Date = new Date();
        const thisMonth = today.getMonth();
        const thisYear = today.getFullYear();
    
        for (const month of purchases) {
            for (const purchase of month.purchases) {
                if (purchase.deleted === true) {
                    continue;
                }
                if (purchase.fromSharedAccount && purchase.disputedBy === undefined) {
                    hasSharedAccountActivity = true;
                }
                const balance = getPurchaseBalance(purchase, userId, this.props.split);
                totalBalance += balance;
                if (month.month === thisMonth && month.year === thisYear) {
                    thisMonthBalance += balance;
                }
            }
            for (const transfer of month.transfers) {
                if (transfer.deleted === true) {
                    continue;
                }
                if (transfer.to === 0 && transfer.from > 0 && transfer.disputedBy === undefined) {
                    hasSharedAccountActivity = true;
                }
                const balance = getTransferBalance(transfer, userId, this.props.split);
                totalBalance += balance;
                if (month.month === thisMonth && month.year === thisYear) {
                    thisMonthBalance += balance;
                }
            }
        }
    


        const paymentLink = (() => {
            if (paymentMethod === "SWISH") {

                return (
                    <span
                        style={{ display: 'flex', flexDirection: 'column', alignItems: 'center' }}
                        onClick={() => {
                            const telephoneCoparent: string = this.props.iAmF1 ? this.props.swishF2 : this.props.swishF1;
                            if (telephoneCoparent && telephoneCoparent.trim().length > 0) {
                                const balance = Math.floor(Math.abs(totalBalance)); 
                                if (balance > 0) {
                                    const paymentLinkSwish = `https://app.swish.nu/1/p/sw/?sw=${telephoneCoparent}&amt=${balance}&cur=${this.props.currency}&msg=Betalning%20Varannan%20Vecka&edit=amt,msg&src=qr`;
                                    window.open(paymentLinkSwish, '_blank');
                                }
                            } else {
                                this.props.showSettings();
                            }
                        }}
                    >
                    <Button 
                        variant='outlined'
                        // size='large'
                        endIcon={<img src={"swish.svg"} className={classes.swish} />}>
                        {tn.lang.pay}
                    </Button>
                  </span>
                  
                );
            }
            if (paymentMethod === "CASHAPP") {
                return (
                    <span
                        style={{ display: 'flex', flexDirection: 'column', alignItems: 'center'}}
                        onClick={() => {
                        if (this.props.cashappF1 && this.props.cashappF1.trim().length > 0) {
                            let cashtag = this.props.iAmF1 ?this.props.cashappF2  : this.props.cashappF1 ;
                            if (!cashtag.startsWith("$")) {
                                cashtag = `$${cashtag}`;
                            }
                            const balance = Math.floor(Math.abs(totalBalance)); 
                            if (balance > 0) {
                                const paymentLinkCashapp = `https://cash.app/${cashtag}/${balance}`;
                                window.open(paymentLinkCashapp, '_blank');
                            }
                        } else {
                            this.props.showSettings();
                        }
                        }}
                    >
                    <Button 
                        variant='outlined'
                        // size='large'
                        endIcon={<img src={"Cash_App-Logo.svg"} className={classes.cashapp} alt="Cash App" />}>
                      {tn.lang.pay}
                    </Button>
                  </span>
                  
                );
            }
            if (paymentMethod === "VENMO") {
                return (
                  <span
                    style={{ display: 'flex', flexDirection: 'column', alignItems: 'center' }}
                    onClick={() => {
                      if (this.props.venmoF1 && this.props.venmoF1.trim().length > 0) {
                        const recipient = this.props.iAmF1 ? this.props.venmoF2 : this.props.venmoF1;
                        const balance = Math.floor(Math.abs(totalBalance));
                        if (balance > 0) {
                            const paymentLinkVenmo = 
                            `https://account.venmo.com/payment-link?audience=public&amount=${balance}&note
                            =Payment%20Varannan%20Vecka&recipients=${recipient}&txn=pay`;
                          window.open(paymentLinkVenmo, '_blank');
                        }
                      } else {
                        this.props.showSettings();
                      }
                    }}
                  >
                    <Button
                        variant='outlined'
                        // size='large'
                        endIcon={<img src={"venmo-icon.svg"} className={classes.venmo} alt="Venmo" />}>
                        {tn.lang.pay}
                    </Button>
                  </span>
                );
              }
          
              if (paymentMethod === "PAYPAL") {
                return (
                    <span
                        style={{ display: 'flex', flexDirection: 'column', alignItems: 'center' }}
                        onClick={() => {
                            if (this.props.paypalF1 && this.props.paypalF1.trim().length > 0) {
                                const paypalName = this.props.iAmF1 ? this.props.paypalF2 : this.props.paypalF1;
                                const balance = Math.floor(Math.abs(totalBalance));
                                if (balance > 0) {
                                    const paymentLinkPayPal = `https://www.paypal.me/${paypalName}/${balance}${this.state.currency}`;
                                    window.open(paymentLinkPayPal, '_blank');
                                }
                            } else {
                                this.props.showSettings();
                            }
                        }}
                    >
                        <Button
                            variant='outlined'
                            // size='large'
                            endIcon={<img src={"paypal-logo.svg"} className={classes.paypal} alt="PayPal" />}>
                            {tn.lang.pay}
                        </Button>
                    </span>
                );
            }
            
              
            return null;
        })();
    

        let method:EcoTransferMethod =  EcoTransferMethod.BANK;
        if (this.state.paymentMethod === "SWISH") {
            method = EcoTransferMethod.SWISH;
        } else if (this.state.paymentMethod === "CASHAPP") {
            method = EcoTransferMethod.CASHAPP;
        } else if (this.state.paymentMethod === "PAYPAL") {
            method = EcoTransferMethod.PAYPAL;
        } else if (this.state.paymentMethod === "VENMO") {
            method = EcoTransferMethod.VENMO;
        } 

        const totalBalanceSubtitle = this.getTotalBalanceSubtitle(totalBalance, hasSharedAccountActivity);

        return (
            <>
                {/** This is the code showing the balance */}
                <div className={classes.card} style={((totalBalance - thisMonthBalance) < -50 && totalBalance < -50)
                    ?{boxShadow:'0px 4px 4px rgb(0 0 0 / 25%), 0px 0px 37px rgb(218 102 97 / 59%)'}:{}}>
                    <div className={classes.monthHeader} >
                        <span style={{textAlign: 'center', width: '100%', padding: '16px 0px', fontSize:'18px', lineHeight:'18px'}}> 
                            {tn.lang.totalBalance}
                        </span>
                    </div>
                    <div className={classes.balanceTitle} >
                        <span style={{marginRight:10}}>
                            {tn.lang.balancePrevious}
                        </span>
                        <span style={{color:(((totalBalance - thisMonthBalance)>1)
                            ?"#58BE59"
                            :((totalBalance - thisMonthBalance)?"#E65F50":"#000000"))}}>
                            {tn.formatNumber((totalBalance - thisMonthBalance), this.props.currency)}
                        </span>
                    </div>
                    <div className={classes.balanceTitle} >
                        <span style={{marginRight:10}}>
                            {tn.lang.balanceThisMonth +tn.lang.getMonthName(thisMonth)+")"}
                        </span>
                        <span style={{color:((thisMonthBalance>1)?"#58BE59":((thisMonthBalance<1)?"#E65F50":"#000000"))}}>
                            {tn.formatNumber((thisMonthBalance), this.props.currency)}
                        </span>
                    </div>
                    <div className={classes.monthHeader} style={{paddingTop: '5px', borderTop: '1px solid #ccc', fontSize:'18px', lineHeight:'18px'}}>
                        <span style={{marginRight:10}}> {tn.lang.sum}:</span>
                        <span style={{color:((totalBalance>1)?"#58BE59":((totalBalance<1)?"#E65F50":"#000000"))}}>
                            {tn.formatNumber((totalBalance), this.props.currency)}
                        </span>
                    </div>
                    <div className={classes.balanceTitle} style={{justifyContent: 'flex-end'}}>
                        <span style={{maxWidth:'100%', textAlign:'right', lineHeight:'16px'}}>
                            {totalBalanceSubtitle} 
                        </span>
                    </div>

                    {totalBalance < -1 && <div style={{padding: '12px 0px'}} onClick={(e) => this.setState(({showRegisterInApp:true}))}>
                        <div style={{pointerEvents:'none'}}>{paymentLink}</div>
                    </div>}
                </div>
                <Dialog
                    open={this.state.showRegisterInApp}
                    onClose={() => this.setState({showRegisterInApp:false})}
                >
                    <div style={{padding: '36px', gap: '24px', display: 'flex', flexDirection: 'column'}}>
                        <div style={{    textAlign: 'center', fontSize: '16px', fontWeight: 200}}>
                            {tn.lang.ecoComeBack}
                        </div>
                        {/* Persist the confirmation before the child click launches the external payment app. */}
                        <div onClickCapture={(e) => {this.setState(({showRegisterInApp:false}));
                            this.props.onNewTransfer(-totalBalance, method)}}>
                            {paymentLink}
                        </div>
                    </div>
                </Dialog>
            </>
        );
    }

    private getTotalBalanceSubtitle(totalBalance:number, hasSharedAccountActivity:boolean):string {
        if (totalBalance > 1) {
            if (hasSharedAccountActivity) {
                const sharedTransferAmount = this.getSharedAccountTransferAmount(totalBalance);
                const coparentName = this.getCoparentName();
                if (sharedTransferAmount !== undefined) {
                    return "(" + tn.lang.totalBalanceGetSharedAlternative(
                        tn.formatNumber(Math.abs(totalBalance), this.props.currency),
                        tn.formatNumber(sharedTransferAmount, this.props.currency),
                        coparentName
                    ) + ")";
                }
            }
            return "(" + tn.lang.totalBalanceGet + ")";
        } else if (totalBalance < -1) {
            if (hasSharedAccountActivity) {
                const sharedTransferAmount = this.getSharedAccountTransferAmount(totalBalance);
                if (sharedTransferAmount !== undefined) {
                    return "(" + tn.lang.totalBalancePaySharedAlternative(
                        tn.formatNumber(Math.abs(totalBalance), this.props.currency),
                        tn.formatNumber(sharedTransferAmount, this.props.currency)
                    ) + ")";
                }
            }
            return "(" + tn.lang.totalBalancePay + ")";
        }
        return "";
    }

    private getSharedAccountTransferAmount(totalBalance:number):number|undefined {
        const percentage = totalBalance > 0
            ? this.state.myPercentage
            : (100 - this.state.myPercentage);
        if (percentage <= 0) {
            return undefined;
        }
        return Math.abs(totalBalance) / (percentage / 100);
    }

    private getCoparentName():string {
        const coparent = this.props.family.find((mem) => mem.role === FamilyMemberType.PARENT && mem.id !== this.props.userId);
        return coparent ? tn.familyMemberName(coparent.id, this.props.family) : tn.lang.unknown;
    }
    
}

const mapStateToProps = (state: { 
    user: { splitSetting:IEcoSplitSetting[], session:any,
        currency:string,swishF1:string,swishF2:string,venmoF1:string,venmoF2:string,
        cashappF1:string, cashappF2:string,paypalF1:string,paypalF2: string, paymentMethod:"SWISH"|"VENMO"|"CASHAPP"|"PAYPAL",}; 
    family: {  family:IFamilyMember[] },  }) => {

    let iAmF1:boolean = true;

    const userId = state?.user?.session?.data?.id ?? 0;
    const family:IFamilyMember[] = Array.isArray(state?.family?.family) ? state.family.family : [];

    const coparent = family.find((mem) => mem.role === FamilyMemberType.PARENT && mem.id !== userId);
    if (coparent) {
        iAmF1 = (userId < coparent.id)
    }

    // Persisted state can hold null here, so only trust arrays.
    let split:IEcoSplitSetting[]|undefined = Array.isArray(state?.user?.splitSetting) ? state.user.splitSetting : undefined;

    if (split === undefined || split.length === 0) {
        split = [{start:0, split: family.filter((mem) => mem.role === FamilyMemberType.PARENT).map((mem) =>
            ({accountId:mem.id, percentage:50}))}]
    }

    return {
        family,
        split,
        iAmF1,
        currency: state.user.currency,
        swishF1: state.user.swishF1,
        swishF2: state.user.swishF2,
        venmoF1: state.user.venmoF1,
        venmoF2: state.user.venmoF2,
        cashappF1: state.user.cashappF1,
        cashappF2: state.user.cashappF2,
        paypalF1: state.user.paypalF1,
        paypalF2: state.user.paypalF2,
        paymentMethod: state.user.paymentMethod,
    };
};

export default connect(mapStateToProps)(withStyles(ecoContainerStyle)(Balance));



// WEBPACK FOOTER //
// ./src/components/economy/Balance.tsx